import * as React from "react";

function IconREAPartner(props) {
  return (
    <svg width={72} height={72} fill="none" {...props}>
  <circle
    cx={35.625}
    cy={36.375}
    r={34.875}
    fill="#f51e84"
  />
  <circle
    cx={35.625}
    cy={36.375}
    r={34.375}
    stroke="#fff"
    strokeOpacity={0.16}
  />
  <g clipPath="url(#prefix__clip0_1726_3932)" fill="#fff">
    <path d="M29.697 38.366c4.54 0 8.22-3.602 8.22-8.046 0-4.443-3.68-8.046-8.22-8.046-4.539 0-8.219 3.603-8.219 8.046 0 4.444 3.68 8.046 8.22 8.046zM29.629 52.667c5.965 0 11.145-2.829 13.755-7.66.15-.277-1.399-5.227-7.863-5.737-1.25-.1-3.288 1.574-5.892 1.574-2.132 0-4.191-1.73-5.657-1.574-6.012.634-8.212 5.543-7.952 6.005 2.656 4.685 7.754 7.392 13.609 7.392zM52.33 30.406c0 2.977-2.465 5.39-5.506 5.39-3.041 0-5.506-2.413-5.506-5.39s2.465-5.39 5.506-5.39c3.041 0 5.506 2.413 5.506 5.39z" />
    <path d="M55.994 40.246c-1.749 3.236-5.22 5.13-9.216 5.13-.571 0-1.132-.038-1.679-.113.016-.64-1.459-4.84-6.53-6.603.83-.976 2.256-2.03 4.42-2.258.472-.05 1.036.191 1.653.456.666.286 1.395.598 2.136.598.994 0 1.864-.363 2.584-.664.545-.228 1.003-.42 1.364-.39 4.33.342 5.367 3.658 5.268 3.844z" />
  </g>
  <defs>
    <clipPath id="prefix__clip0_1726_3932">
      <path fill="#fff" transform="translate(16 16)" d="M0 0h40v40H0z" />
    </clipPath>
  </defs>
</svg>


  );
}

const MemoIconREAPartner = React.memo(IconREAPartner);
export default MemoIconREAPartner;
